import React, { useState } from 'react'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import CommonScreen from '../admin/component/CommonScreen'
import { connect } from 'react-redux'
import { Select, Button, Input } from 'antd'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core/selectors'
import * as api from '../api/pgads'
import { DayMap, HOURS } from 'core'

const hoursMap = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  '10': '10',
  '11': '11',
  '12': '12',
  '13': '13',
  '14': '14',
  '15': '15',
  '16': '16',
  '17': '17',
  '18': '18',
  '19': '19',
  '20': '20',
  '21': '21',
  '22': '22',
  '23': '23',
  '24': '24',
}
const title = 'Peak Avail. Report Peak Definition'

const PeakDefinition = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '20px',
        }}
      >
        Schedule :
      </div>
      <Input
        style={{ width: '300px' }}
        value={insertData.schedule}
        onChange={e =>
          setInsertData({ ...insertData, schedule: e.target.value })
        }
        maxLength={15}
      />
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        Start Day :
      </div>
      <Select
        style={{ width: '100%' }}
        value={insertData.startDay}
        onChange={val => setInsertData({ ...insertData, startDay: val })}
      >
        {Object.keys(DayMap).map(k => (
          <Select.Option key={k} value={k}>
            {DayMap[k]}
          </Select.Option>
        ))}
      </Select>
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        End Day :
      </div>
      <Select
        style={{ width: '100%' }}
        value={insertData.endDay}
        onChange={val => setInsertData({ ...insertData, endDay: val })}
      >
        {Object.keys(DayMap).map(k => (
          <Select.Option key={k} value={k}>
            {DayMap[k]}
          </Select.Option>
        ))}
      </Select>
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        Start Hour :
      </div>
      <Select
        style={{ width: '100%' }}
        value={insertData.startHour}
        onChange={val => setInsertData({ ...insertData, startHour: val })}
      >
        {HOURS.map(k => (
          <Select.Option key={k} value={k}>
            {k}
          </Select.Option>
        ))}
      </Select>
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        End Hour :
      </div>
      <Select
        style={{ width: '100%' }}
        value={insertData.endHour}
        onChange={val => setInsertData({ ...insertData, endHour: val })}
      >
        {HOURS.map(k => (
          <Select.Option key={k} value={k}>
            {k}
          </Select.Option>
        ))}
      </Select>
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        Holiday :
      </div>
      <Select
        style={{ width: '100%' }}
        value={insertData.holiday}
        onChange={val => setInsertData({ ...insertData, holiday: val })}
      >
        <Select.Option key="Y" value="Y">
          Yes
        </Select.Option>
        <Select.Option key="N" value="N">
          No
        </Select.Option>
      </Select>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={PeakDefinitionHeaders}
      saveTask={api.savePeakDefinition}
      retrieveTask={api.getPeakDefinition}
      deleteTask={api.deletePeakDefinition}
      autoRetrieve
      sortOptions={PeakDefinitionHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(PeakDefinition)

export const PeakDefinitionHeaders = [
  strCol({
    ident: 'schedule',
    display: 'Schedule',
    isKey: true,
    width: 150,
    ellipsis: true,
  }),
  strCol({
    ident: 'startDay',
    display: 'Start Day',
    ...toSelectionColProps(DayMap),
  }),
  strCol({
    ident: 'endDay',
    display: 'End Day',
    ...toSelectionColProps(DayMap),
  }),
  numCol({
    ident: 'startHour',
    display: 'Start Hour',
    displayFormat: '0',
    ...toSelectionColProps(hoursMap),
  }),
  numCol({
    ident: 'endHour',
    display: 'End Hour',
    displayFormat: '0',
    // ...toSelectionColProps(HoursMap),
  }),
  strCol({
    ident: 'holiday',
    display: 'Holiday',
  }),
  modifierCol,
  modifiedDateCol,
]
